import React, { useState, useEffect } from "react";
import IconButton from "@material-ui/core/IconButton";
import Popover from "@material-ui/core/Popover";
import DateRangeIcon from "@material-ui/icons/DateRange";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment";
import "./periodExclusionRenderer.css";

export const PeriodExclusionRenderer = ({ value, name, fieldUpdateHandler }) => {
  const [ranges, setRanges] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // Парсим входящее значение при монтировании и обновлении value
  useEffect(() => {
    if (value) {
      const parsedRanges = value.split(",").map(range => {
        const [start, end] = range.split(":");
        return { start, end };
      });
      setRanges(parsedRanges);
    } else {
      setRanges([]);
    }
  }, [value]);

  const handleOpenPicker = (event) => {
    setAnchorEl(event.currentTarget);
    // Сбрасываем значения при открытии
    setStartDate("");
    setEndDate("");
  };

  const handleClosePicker = () => {
    setAnchorEl(null);
  };

  const handleAddRange = () => {
    if (startDate && endDate) {
      // Проверяем, что начальная дата не больше конечной
      if (moment(startDate).isAfter(endDate)) {
        alert("Начальная дата не может быть больше конечной");
        return;
      }

      // Форматируем даты в YYYY-MM-DD с помощью moment
      const start = moment(startDate).format("YYYY-MM-DD");
      const end = moment(endDate).format("YYYY-MM-DD");

      // Проверяем, не существует ли уже такой диапазон
      const newRangeStr = `${start}:${end}`;
      const existingRanges = ranges.map(r => `${r.start}:${r.end}`);

      if (!existingRanges.includes(newRangeStr)) {
        const newRanges = [...ranges, { start, end }];
        setRanges(newRanges);

        // Формируем строку для сохранения
        const resultString = newRanges.map(r => `${r.start}:${r.end}`).join(",");
        fieldUpdateHandler(name, resultString);
      }

      handleClosePicker();
    }
  };

  const handleRemoveRange = (indexToRemove) => {
    const newRanges = ranges.filter((_, index) => index !== indexToRemove);
    setRanges(newRanges);

    // Формируем строку для сохранения
    const resultString = newRanges.map(r => `${r.start}:${r.end}`).join(",");
    fieldUpdateHandler(name, resultString);
  };

  return (
      <>
        <div className="period__exclusion__container">
          {/* Отображаем существующие диапазоны */}
          {ranges.map((range, index) => (
            <div
              key={range.start + ":" + range.end}
              className="period__exclusion__chip"
            >
            <span className="period__exclusion__chip-text">
              {`${moment(range.start).format("DD.MM.YYYY")} - ${moment(range.end).format(
                "DD.MM.YYYY")}`}
            </span>
              <IconButton
                size="small"
                onClick={() => handleRemoveRange(index)}
                className="period__exclusion__chip-close"
              >
                <CloseIcon/>
              </IconButton>
            </div>
          ))}

          {/* Кнопка для открытия календаря */}
          <IconButton
            size="small"
            onClick={handleOpenPicker}
            className="period__exclusion__add-button"
          >
            <DateRangeIcon/>
          </IconButton>
        </div>

        {/* Popover с календарями */}
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClosePicker}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left"
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left"
          }}
        >
          <div className="period__exclusion__popover-content">
            <div className="period__exclusion__date-field">
              <div className="period__exclusion__date-label">
                Начальная дата:
              </div>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="period__exclusion__date-input"
              />
            </div>

            <div className="period__exclusion__date-field">
              <div className="period__exclusion__date-label">
                Конечная дата:
              </div>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="period__exclusion__date-input"
              />
            </div>

            <div className="period__exclusion__actions">
              <button
                onClick={handleClosePicker}
                className="period__exclusion__cancel-button"
              >
                Отмена
              </button>
              <button
                onClick={handleAddRange}
                disabled={!startDate || !endDate}
                className="period__exclusion__add-range-button"
              >
                Добавить диапазон
              </button>
            </div>
          </div>
        </Popover>
      </>
  );
};